import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiChecklist2ScheduleListComponent } from './schedule-list.component';
import { FiAppTextSharedModule } from '../../../app-text';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { FiWhenScrolledModule } from '../../../fi-directives/when-scrolled/when-scrolled.module';
import { FiWrapperTableModule } from '../../../fi-wrapper-table/fi-wrapper-table.module';
import { FiLineClampModule } from '../../../fi-directives/fi-line-clamp/fi-line-clamp.module';
import { FiFormatDateModule } from '../../../fi-format-date/fi-format-date.module';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
    imports: [
        CommonModule,
        FiAppTextSharedModule,
        MatIconModule,
        MatCardModule,
        FiWhenScrolledModule,
        FiWrapperTableModule,
        FiLineClampModule,
        FiFormatDateModule,
        FiLocalSearch2Module,
        FiItemsListModule,
        MatButtonModule,
    ],
    declarations: [FiChecklist2ScheduleListComponent],
})
export class FiChecklist2ScheduleListModule {}
